export { getParent } from '@fluentui/dom-utilities';
